import { Button, Modal } from "@mui/material";
import { CloseModalButton, LeavePageModalButtons, LeavePageModalWrapper } from "./LeavePageModal.styles";
import { ExitTruckText, YesExitOrder } from "constants/text";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import useB2CAccount from "auth/useB2CAccount";
import { cartActions } from "features/reducers/replacementOrder/cart.ts";
import { submittingReplacementOrderActions } from "features/reducers/replacementOrder/submittingReplacementOrder.ts";
import { useUserLocation } from "hooks/useUserLocation.ts";

interface Props {
	open: boolean;
	url: string;
	continueOrdering: () => void;
	closeModal?: () => void;
	isOnOrderDetailsPage?: boolean;
	orderDetailId?: string;
	headerText: string;
	subHeaderText: string;
	continueButtonText: string;
}

const LeavePageModal = ({
	open,
	url,
	continueOrdering,
	closeModal,
	isOnOrderDetailsPage = false,
	orderDetailId,
	headerText,
	subHeaderText,
	continueButtonText
}: Props) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { isTrucksPage } = useUserLocation();
	const { logout } = useB2CAccount();
	const homeUrl = import.meta.env.VITE_APP_SALESFORCE_DASHBOARD_URL ?? "https://tandem.cabinetworksgroup.com";
	const handleExitOrder = async () => {
		if (isOnOrderDetailsPage && closeModal) {
			closeModal();
			return;
		}
		if (closeModal) closeModal();
		dispatch(cartActions.resetCart());
		dispatch(submittingReplacementOrderActions.resetOrder());
		if (url === homeUrl) {
			window.location.href = homeUrl;
		} else if (url === "logout") {
			await logout();
		} else {
			if (url.startsWith(homeUrl)) {
				window.location.href = url;
			} else {
				navigate(url);
			}
		}
	};

	const handleContinueOrderingOnOrderDetailsPage = () => {
		if (isOnOrderDetailsPage) {
			navigate(`/replacements/${orderDetailId}`);
		} else {
			continueOrdering();
		}
	};
	return (
		<Modal
			open={open}
			data-testid="leave-page-modal"
		>
			<LeavePageModalWrapper>
				<h6>{headerText}</h6>
				<p>{subHeaderText}</p>
				<CloseModalButton onClick={handleContinueOrderingOnOrderDetailsPage} />
				<LeavePageModalButtons>
					<Button
						variant="outlined"
						onClick={handleExitOrder}
						data-testid="leave-page-modal-exit-order-button"
					>
						{isTrucksPage ? ExitTruckText : YesExitOrder}
					</Button>
					<Button
						variant="contained"
						onClick={handleContinueOrderingOnOrderDetailsPage}
						data-testid="leave-page-modal-continue-ordering-button"
					>
						{continueButtonText}
					</Button>
				</LeavePageModalButtons>
			</LeavePageModalWrapper>
		</Modal>
	);
};

export default LeavePageModal;
